import { render, staticRenderFns } from "./ConfigurationSetting.vue?vue&type=template&id=7f829d40&scoped=true&"
import script from "./ConfigurationSetting.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationSetting.vue?vue&type=style&index=0&id=7f829d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f829d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCheckbox,VDivider})
